import { render, staticRenderFns } from "./add-repair-materials.vue?vue&type=template&id=1fe85dea&scoped=true&"
import script from "./add-repair-materials.vue?vue&type=script&lang=js&"
export * from "./add-repair-materials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe85dea",
  null
  
)

export default component.exports